<div class="ibox">
    <iboxtools *ngIf="datosIIGG != null"
               [Title]=""
               [isHistory]=true
               [DateInit]="datosIIGG?.desde"
               [DateEnd]="datosIIGG?.hasta"
               [PeriodList]="datosList"
               [IsEditing]="isEditing"
               (PeriodChange)="OnPeriodChange($event)"
               (NewChange)="OnNewChange($event)"
               (EditChange)="OnEditChange($event)"
               (SaveChange)="OnSaveChange($event)"
               (CutChange)="OnCutChange($event)"
               (DeleteChange)="OnDeleteChange($event)"
               (CancelChange)="OnCancelChange($event)"
               [Permiso]="permisoEdicion">
    </iboxtools>
    <div class="ibox-content" *ngIf="datosIIGG != null">
      <mat-error *ngIf="datosInvalida" class="datosInvalida">{{MensajeError}}</mat-error>
      <form [formGroup]="form">
        <div class="row" hidden="true">
          <input formControlName="id" name="id" type="text" class="form-control" />
          <input formControlName="personal" name="personal" type="text" class="form-control" />
        </div>
        <div class="row panel panel-warning" *ngIf="!disabledEditing">
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
              <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
              <mat-error *ngIf="registerFormControl.desde.errors?.desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
              </mat-error>
              <mat-error *ngIf="registerFormControl.desde.errors?.anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al límite de retroactividad {{gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
              <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
              <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)">
                La Fecha no puede ser menor que la Fecha Desde
              </mat-error>
            </div>
          </div>
        </div>
        <div>
        </div>
        <div class="combo row">
            <div class="col-lg">
                <p-checkbox formControlName="agenteRetencion" binary="true" label="Agente Retención"></p-checkbox>
            </div>
            <div class="col-lg">
                <p-checkbox formControlName="topeRetencion" binary="true" label="Tope de Retención"></p-checkbox>
            </div>
        </div>
        <div class="combo row">
            <div class="col-lg">
                <p-checkbox formControlName="noAplicaMinimo" binary="true" label="No Aplica Mín. No imponible"></p-checkbox>
            </div>
            <div class="col-lg">
                <p-checkbox formControlName="certificadoExclusion" binary="true" label="Certificado de Exclusión de Retención"></p-checkbox>
            </div>
        </div>
      </form>
    </div>
  </div>
  
  <div class="ibox-content m-b-sm border-bottom" *ngIf="datosIIGG == null && cargaCompleta">
    <button type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
    <div class="p-xs">
      <div class="float-left m-r-md">
        <i class="fa fa-globe text-navy mid-icon"></i>
      </div>
      <h2>Empleado sin Datos de IIGG</h2>
      <span>El empleado no tiene Datos de IIGG.</span>
    </div>
  </div>
  
  
  